import * as AppState from '../../../../../../store/app.state';
import * as studentsActions from '../action/students-statistics.actions';
import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';

/**
 * assignment reducer used to updated store values based on certain action.
 */

/**
 * State interface extends App state State and add user state to the main state.
 */
export interface State extends AppState.State {
   studentsStatistics: studentsStatisticsState;
}

/**
 * An SubjectState interface, which represents the blueprint of the User State.
 */
export interface studentsStatisticsState {
   studentsStatistics: any;
   studentsNumber: number;
   errorMessage: string;
}

/**
 * SubjectState initial state.
 */
export const initialState: studentsStatisticsState = {
   studentsStatistics: null,
   studentsNumber: null,
   errorMessage: null,
};

/**
 * Subject Reducer used to update the state upon Subject actions.
 */
export const studentsStatisticsReducer = createReducer(
   initialState,
   /**
    * On loadSubjectsDetailsSuccess action updated current state with the following properties.
    */
   on(
      studentsActions.loadStudentsStatisticsSuccess,
      (state, action): studentsStatisticsState => {
         return {
            ...state,
            studentsStatistics: action.data.studentDetails,
            studentsNumber: action.data.studentsNumber,
         };
      }
   ),

   /**
    * On loadSubjectsDetailsFailure action updated current state with the following properties.
    */
   on(
      studentsActions.loadStudentsStatisticsFailure,
      (state, action): studentsStatisticsState => {
         return {
            ...state,
            errorMessage: action.error,
         };
      }
   )
);
